import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import Navbar from '../inc/Navbar';
import SuperDeluxeroom from './SuperDeluxerom';
function Room() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <SuperDeluxeroom/>
        <br/>
               <ScrollToTop smooth top="100" color="darkgoldenrod" />

    </div>
  )
}

export default Room